import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOnboardingStatus } from './api/useOnboarding';
import { useStateContext } from '@/contexts/ContextProvider';

export default function RequireOnboardingAccess({ children }: { children: ReactNode }) {
    const { user, setNotifications } = useStateContext();
    const { data: status, isLoading } = useOnboardingStatus();

    // Determine the redirect target + notification (pure derivation, no side effect)
    let redirectTo: string | null = null;
    let notification: { error?: string; info?: string } | null = null;

    if (!isLoading) {
        if (!user) {
            redirectTo = '/login';
        } else if (!status) {
            redirectTo = '/';
        } else if ((user as any).id !== status.primary_admin_user_id) {
            redirectTo = '/';
            notification = { error: "Accès réservé à l'administrateur principal." };
        } else if (status.status === 'completed') {
            redirectTo = '/';
            notification = { info: 'Onboarding déjà complété.' };
        } else if (status.status === 'disabled') {
            redirectTo = '/';
            notification = { error: 'Wizard désactivé. Contactez TriggerFlow.' };
        }
    }

    // Side effect: fire notification AFTER render
    useEffect(() => {
        if (notification) setNotifications(notification as any);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notification]);

    if (isLoading) return null;
    if (redirectTo) return <Navigate to={redirectTo} replace />;
    return <>{children}</>;
}
